const GearboxIcon = ({ size = 24 }: { size?: number }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.6"
		strokeLinecap="round"
		strokeLinejoin="round"
		role="img"
		aria-label="Gearbox"
	>
		<title>Gearbox</title>
		<circle cx="12" cy="12" r="9" />
		<path d="M7 8v8M17 8v8M7 12h10M12 8v3M12 13v3" />
	</svg>
);

const OdometerIcon = ({ size = 24 }: { size?: number }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.7"
		strokeLinecap="round"
		strokeLinejoin="round"
		role="img"
		aria-label="Odometer"
	>
		<title>Odometer / Mileage</title>
		<circle cx="12" cy="12" r="9" />

		<path d="M12 3v2.2M7.2 4.5l1 1.7M4.5 7.2l1.7 1M3 12h2.2M4.5 16.8l1.7-1M7.2 19.5l1-1.7M12 18.8v2.2M16.8 19.5l-1-1.7M19.5 16.8l-1.7-1M18.8 12h2.2M19.5 7.2l-1.7 1M16.8 4.5l-1 1.7" />

		<path d="M12 12l4-2.5" />
		<circle cx="12" cy="12" r="1.4" fill="currentColor" />

		<rect x="9" y="15" width="6" height="2" rx=".75" stroke="currentColor" strokeWidth="0.75" />
	</svg>
);

const CalendarIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.6"
		strokeLinecap="round"
		strokeLinejoin="round"
		role="img"
		aria-label="Date"
	>
		<title>Date</title>
		<rect x="3" y="5" width="18" height="16" rx="2.5" ry="2.5" />
		<path d="M8 3v4M16 3v4" />
		<path d="M3 9h18" />
		<path d="M8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01M16 17h.01" />
	</svg>
);

export { GearboxIcon, OdometerIcon, CalendarIcon };
